<template>
  <v-container>
    <v-list three-line>
      <template>
        <v-subheader
        >お知らせ</v-subheader>
        <div>
          <NotificationListItem :noticeList="noticeList" :parentComponent="componentName" :setUnReadNotice="setUnReadNotice" />
        </div>
        <v-row justify="end">
          <v-pagination
            class="my-5"
            v-model="page"
            :length="totalPage"
            @input="getPageNotice"
            circle
            color = "#5E00BC"
            :total-visible="7"
          ></v-pagination>
        </v-row>
      </template>
    </v-list>
  </v-container>
</template>
<script>
import NotificationListItem from '../molecules/NotificationListItem.vue';
export default {
  data() {
    return {
      page: 1,
      isLoading: false,
      isMoreData: true,
      noticeList: [],
      totalPage: 0,
    };
  },
  name: 'NotificationIndex',
  components: {
    NotificationListItem,
  },
  async created() {
    if (this.$store.getters['auth/isAuth'] !== '') {
      this.getNotice(this.page);
    }
  },
  computed: {
    componentName() {
      return this.$options.name;
    },
    getUserCode() {
      return this.$store.getters['auth/isUserCode']
    },
  },
  methods: {
    getPageNotice(page) {
      this.noticeList = this.getNotice(page);
    },
    async getNotice(page) {
      await this.$store.dispatch('notice/get', page);
      this.noticeList = this.$store.getters['notice/noticeList'];
      const noticeCount = this.$store.getters['notice/noticeCount'];
      this.totalPage = Math.ceil(noticeCount/10);
    },
    async setUnReadNotice() {
      await this.$store.dispatch('notice/getUnReadNotice');
    },
  }
}
</script>
<style scoped>
</style>